import React, { useEffect, useState } from "react";

import "../styles/BookingDetails.css";
import { BookingInfo, ComponentRenderer } from ".";
import useFetchData from "../utils/useFetchData";
import { config, LABELS, useViewport, service } from "../utils";
import { CountdownTimer } from ".";
import { getLatestTimer } from "../../../utils/timer";

const BookingDetails = (props) => {
  const { customClass } = props;
  const [exp, setExp] = useState(false);
  const [fromTimeInMilliseconds, setFromtime] = useState(Date.now());
  const [showTimer, setShowTimer] = useState(false);
  
  const { status, response } = useFetchData(config.PAGE_ID.BOOKING_DETAILS);

  const handleClick = () => {
    setExp(!exp);
  };

  useEffect(() => {
    const timer = getLatestTimer();
    const { time, success } = timer;
    if (success) {
      setFromtime(time);
    }
    setShowTimer(true);
  }, []);

  const { width } = useViewport();
  const breakpoint = config.BREAKPOINT;
  return (
    <ComponentRenderer status={status}>

      <div className={`${customClass} bookingDetails ${exp?'noBdr':''}`}>
        <div className="bookingDetails__head">
          {width < breakpoint && (
            <h3 className="makeFlex hrtlCenter spaceBetween flexOne">
              {LABELS.BOOKING_DETAILS}
              {exp ? (
                <span className="arrow--blue up" onClick={handleClick}></span>
              ) : (
                <span className="arrow--blue down" onClick={handleClick}></span>
              )}
            </h3>
          )}
          {width > breakpoint && <h3>{LABELS.BOOKING_DETAILS}</h3>}
          {/* countdowntimer */}
          {
            showTimer &&
            <CountdownTimer
              totalTimeInSeconds={9.95*60}
              fromTimeInMilliseconds={fromTimeInMilliseconds}
              buffer={0}
            />
          }
        </div>
        {width > breakpoint && (
          <BookingInfo response={response} status={status} />
        )}
        {exp && (
          <BookingInfo response={response} status={status} />
        )}
      </div>
    </ComponentRenderer>
  );
};

export default BookingDetails;
